import { SegmentedControl, type SegmentedControlProps } from "@mantine/core";
import type {
  EcosystemHeadQuestionnaireLanguageId,
  EcosystemHeadQuestionnaireLanguages,
} from "../../../../../shared/ecosystemHeadQuestionnaire";

type Props = {
  languages: EcosystemHeadQuestionnaireLanguages;
  value: EcosystemHeadQuestionnaireLanguageId;
  onChange: (side: EcosystemHeadQuestionnaireLanguageId) => void;
  size?: SegmentedControlProps["size"];
};

export default function QuestionnaireLanguageToggle({
  languages,
  value,
  onChange,
  size = "sm",
}: Props) {
  const data = languages.languages.map((language) => ({
    value: language.id,
    label: language.name,
  }));
  const selected = data.some((item) => item.value === value) ? value : data[0]?.value;

  return (
    <SegmentedControl
      size={size}
      value={selected}
      onChange={(next) => onChange(next)}
      data={data}
    />
  );
}
